module.exports = __webpack_public_path__ + "resources/img/equipment_tab4_img2.b40c428bbac757fdee8bc308cd9ff33b.jpg";